import { render } from "./HomeIcon.vue?vue&type=template&id=ffe441ca&scoped=true"
import script from "./HomeIcon.vue?vue&type=script&lang=js"
export * from "./HomeIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe441ca"]])

export default __exports__